import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { share } from 'rxjs/operators';

import { BaseService } from './base.service';
import { ClientModel } from '../models/client.model';

@Injectable()
export class ClientService extends BaseService {

    public clients$: Observable<ClientModel[]>;
    private clientsObserver: Observer<ClientModel[]>;
    private clientList: { clients: ClientModel[] };

    constructor() {
        super();
        this.clients$ = new Observable<ClientModel[]>((observer: Observer<ClientModel[]>) => { this.clientsObserver = observer; }).pipe(share());
        this.clientList = {
            clients: []
        };
    }

    ////force an update of the current list of clients, this will go to the local storage and parse them out
    public updateClients() {
        this.clientList.clients = [];
        var clientList = this.getUserClientsList();
        if (clientList != null) {
            for (var i = 0; i < clientList.length; i++) {
                var client = clientList[i];
                var newClient = new ClientModel();
                newClient.name = client.name;
                newClient.clientGuid = client.clientGuid;
                if (client.profile != undefined && client.profile != null) {
                    newClient.smsEnabled = client.profile.smsEnabled;
                    if (newClient.smsEnabled && client.profile.smsNumber !== undefined && client.profile.smsNumber != null && client.profile.smsNumber.trim() != '')
                        newClient.smsNumber = this.formatPhoneNumber(client.profile.smsNumber);
                    else
                        newClient.smsNumber = '';
                }
                this.clientList.clients.push(newClient);
            }

            this.clientList.clients = this.clientList.clients.sort(function (a, b) { return a.name > b.name ? 1 : (a.name < b.name ? -1 : 0) });
            this.clientsObserver.next(this.clientList.clients);
            this.selectClient();

            
            } else {
            console.log('!!! Warning !!! User has no client list.');
        }
            }

    public selectClient() {
        var lastSelectedClient: string = localStorage.getItem('selectedClient');
        if (lastSelectedClient !== undefined && lastSelectedClient != null && lastSelectedClient.trim() != 'null' && lastSelectedClient.trim() != '') {
            var selectedClient: any = JSON.parse(lastSelectedClient);
            if((this.clientList.clients.findIndex((f: any) => { return f.clientGuid == selectedClient.clientGuid; }) >= 0)) {
                this.setSelectedClient(selectedClient);
            } else {
                this.setSelectedClient(this.clientList.clients[0]);
            }
        } else {
            this.setSelectedClient(this.clientList.clients[0]);
        }
    }

    public loadClientByKey(clientKey: string) {

        var newClient = new ClientModel();
        newClient.name = '';
        newClient.clientGuid = clientKey;
        newClient.smsEnabled = false;
        newClient.smsNumber = '';
        this.clientList.clients.push(newClient);
        this.setSelectedClient(newClient);
    }

    public formatPhoneNumber(phoneNumber: string) {
        var formattedNumber = phoneNumber.replace('(', '').replace(')', '').replace('-', '');
        if (formattedNumber.length == 10) {
            var temp = formattedNumber.substring(0, 3) + '-' + formattedNumber.substring(3, 6) + '-' + formattedNumber.substring(6, 10);
            formattedNumber = temp;
        }
        return formattedNumber;
    }


}